import React from 'react';
import './WeekendAndIsraeliHolidaysWarning.scss';
import { useTranslation } from 'react-i18next';
import PluginUtils, { PluginType } from '../PluginUtils';

import { OrderPageTypography } from '../themedComponents/OrderPageTypography';
import { OrderPageIntent } from '../OrderPageIntent';

const WeekendAndIsraeliHolidaysWarning = ({
  orderPage,
  shouldHideWeekends,
  orderPageIntent,
}: {
  orderPage: any;
  shouldHideWeekends?: boolean;
  orderPageIntent?: OrderPageIntent;
}) => {
  const { t } = useTranslation();

  if (!PluginUtils.getPluginData(orderPage.plugins, PluginType.WEEKEND_AND_ISRAELI_HOLIDAYS)) {
    return null;
  }
  let text = t('order_page.weekendWarning', {
    percent: (
      (PluginUtils.getPluginData(orderPage.plugins, PluginType.WEEKEND_AND_ISRAELI_HOLIDAYS).multiply - 1) *
      100.0
    ).toFixed(0),
  });
  if (orderPageIntent === OrderPageIntent.REDEEM_GIFT_CARD) {
    if (shouldHideWeekends) {
      text = t('order_page.weekendWarningRedeemGiftCardNotOnWeekends');
    } else {
      text = t('order_page.weekendWarningRedeemGiftCardAlsoOnWeekends');
    }
  }
  return (
    <OrderPageTypography variant={'h6'} style={{ opacity: 0.7 }}>
      {text}
    </OrderPageTypography>
  );
};

export default WeekendAndIsraeliHolidaysWarning;
